export {
  mapCreateModelToFhirCommunication,
  mapFhirCommunicationToModel,
  mapModelToFhirCommunication,
} from './mapping';
export type {
  Communication,
  CommunicationContent,
  CommunicationCreateRequest,
  CommunicationGetAllResponse,
  CommunicationGetResponse,
  CommunicationSearch,
  Conversation,
  ConversationContent,
  ConversationCreateRequest,
  ConversationGetRequest,
  ConversationGetResponse,
} from './schema';
export {
  CommunicationCategoryCode,
  CommunicationChannelCode,
  CommunicationChannelCodeDescription,
  CommunicationCreateRequestSchema,
  CommunicationGetAllResponseSchema,
  CommunicationGetResponseSchema,
  CommunicationSearchSchema,
  CommunicationTopicCode,
  ConversationCreateRequestSchema,
  ConversationGetRequestSchema,
  ConversationGetResponseSchema,
  communicationContentCreateSchema,
  communicationContentSchema,
  conversationContentSchema,
} from './schema';
